import React, { Component } from "react";

class ExtensionContext extends Component {
  render() {
    return (
      <div>
        <p>
          Each location with its relevant type provides a context, which
          consists of a set of parameters. The context is accessible either
          through the HTTPS Post body, or through JavaScript interaction.
        </p>
        <table cellSpacing="0" cellPadding="0">
          <tbody>
            <tr>
              <th className="table-top-header-left">
                <p>
                  <span>Parameter name</span>
                </p>
              </th>
              <th className="table-top-header-right">
                <p>
                  <span>Description</span>
                </p>
              </th>
            </tr>
            <tr>
              <td className="table-inner-header-left" rowSpan="2">
                <p>
                  <span>extension</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>General extension details.</span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header">
                <table cellSpacing="0" cellPadding="0">
                  <tbody>
                    <tr>
                      <th className="table-inner-cell-left">
                        <p>
                          <span>Parameter name</span>
                        </p>
                      </th>
                      <th className="table-inner-cell-right">
                        <p>
                          <span>Description</span>
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>name</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>The displayed name of the extension.</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>provider</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>Extension provider name.</span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>version</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>
                            Your own extension version (for version control).
                          </span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>extension-key</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>
                            User defined value.
                            <br />
                            This value can be used to verify which client
                            accessed your service.
                          </span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-cell-bottom-left">
                        <p>
                          <span>custom-data</span>
                        </p>
                      </td>
                      <td className="table-cell-bottom_right">
                        <p>
                          <span>
                            Custom key-value configuration dictionary.
                          </span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header-left" rowSpan="2">
                <p>
                  <span>client-extensions-api</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>Current SmartConsole extension platform details.</span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header">
                <table cellSpacing="0" cellPadding="0">
                  <tbody>
                    <tr>
                      <th className="table-inner-cell-left">
                        <p>
                          <span>Parameter name</span>
                        </p>
                      </th>
                      <th className="table-inner-cell-right">
                        <p>
                          <span>Description</span>
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <td className="table-cell-bottom-left">
                        <p>
                          <span>version</span>
                        </p>
                      </td>
                      <td className="table-cell-bottom_right">
                        <p>
                          <p>
                            <span>
                              SmartConsole extension platform version.
                            </span>
                          </p>
                          <p>
                            <span>
                              See{" "}
                              <a href="#Extension Versions">
                                SmartConsole extension platform available
                                versions
                              </a>
                              .
                            </span>
                          </p>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header-left">
                <p>
                  <span>management-server-api</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>
                    <a href="#Management API">Management API</a> details on
                    current environment.
                  </span>
                </p>
              </td>
            </tr>

            <tr>
              <td className="table-inner-header-left">
                <p>
                  <span>work-session</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>
                    See{" "}
                    <a href="https://sc1.checkpoint.com/documents/latest/APIs/index.html#cli/show-session">
                      Management API Reference
                    </a>{" "}
                    for work session output.
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header-left" rowSpan="2">
                <p>
                  <span>event</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  When you are in SmartConsole and navigat to an extension, you
                  only navigate to a specific location.
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header">
                <table cellSpacing="0" cellPadding="0">
                  <tbody>
                    <tr>
                      <th className="table-inner-cell-left">
                        <p>
                          <span>Parameter name</span>
                        </p>
                      </th>
                      <th className="table-inner-cell-right">
                        <p>
                          <span>Description</span>
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <td className="table-cell-left">
                        <p>
                          <span>trigger-id</span>
                        </p>
                      </td>
                      <td className="table-cell-right">
                        <p>
                          <span>
                            Unique ID to identify the action triggered by the
                            extension.
                          </span>
                        </p>
                      </td>
                    </tr>
                    <tr>
                      <td className="table-cell-bottom-left">
                        <p>
                          <span>objects</span>
                        </p>
                      </td>
                      <td className="table-cell-bottom_right">
                        <p>
                          <span>See relevant objects per location.</span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
        <h4 id="Management API">Management API</h4>
        <p>details on current environment.</p>
        <table cellSpacing="0" cellPadding="0">
          <tbody>
            <tr>
              <th className="table-top-header-left">
                <p>
                  <span>Parameter name</span>
                </p>
              </th>
              <th className="table-top-header-right">
                <p>
                  <span>Description</span>
                </p>
              </th>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>url</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>Path to Management API server.</span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>version</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>Management API version.</span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>sid</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>
                    Allocated session ID to communicate with Management API.
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-cell-left">
                <p>
                  <span>sid-permission</span>
                </p>
              </td>
              <td className="table-cell-right">
                <p>
                  <span>Allocated session ID permission.</span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header-left" rowSpan="2">
                <p>
                  <span>certificate-fingerprint</span>
                </p>
              </td>
              <td className="table-inner-header-right">
                <p>
                  <span>
                    Management API server certificate fingerprint details.
                  </span>
                </p>
              </td>
            </tr>
            <tr>
              <td className="table-inner-header">
                <table cellSpacing="0" cellPadding="0">
                  <tbody>
                    <tr>
                      <th className="table-inner-cell-left">
                        <p>
                          <span>Parameter name</span>
                        </p>
                      </th>
                      <th className="table-inner-cell-right">
                        <p>
                          <span>Description</span>
                        </p>
                      </th>
                    </tr>
                    <tr>
                      <td className="table-cell-bottom-left">
                        <p>
                          <span>sha1</span>
                        </p>
                      </td>
                      <td className="table-cell-bottom_right">
                        <p>
                          <span>Certificate fingerprint.</span>
                        </p>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default ExtensionContext;
